<template>
  <div class="pb-8">
    <div class="form-section-base__controls">
      <v-radio-group v-model="v.role.$model" row>
        <div class="d-flex">
          <v-radio class="mb-0" label="Физическое лицо" :value="Role.PERSON" />
          <v-radio
            class="mb-0"
            label="Юридическое лицо"
            :value="Role.ORGANIZATION"
          />
          <v-radio
            class="mb-0"
            label="Иностранное юридическое лицо"
            :value="Role.FOREIGN_ORGANIZATION"
          />
        </div>
      </v-radio-group>
    </div>

    <Person v-if="v.role.$model === Role.PERSON" :v="v.person" />

    <Organization
      v-if="v.role.$model === Role.ORGANIZATION"
      :v="v.organization"
    />

    <ForeignOrganization
      v-if="v.role.$model === Role.FOREIGN_ORGANIZATION"
      :v="v.foreignOrganization"
    />

    <v-btn
      v-if="canDelete"
      depressed
      color="primary"
      class="button-base"
      @click="$emit('delete')"
    >
      Удалить
    </v-btn>
  </div>
</template>

<script>
import cloneDeep from 'clone-deep';

import { Role } from '@/utils/dictionaries';
import Person, { personModel, personValidation } from './Person';
import Organization, {
  organizationModel,
  organizationValidation,
} from './Organization';
import ForeignOrganization, {
  foreignOrganizationModel,
  foreignOrganizationValidation,
} from './ForeignOrganization';

export const notificantModel = {
  role: Role.PERSON,
  [Role.PERSON]: cloneDeep(personModel),
  [Role.ORGANIZATION]: cloneDeep(organizationModel),
  [Role.FOREIGN_ORGANIZATION]: cloneDeep(foreignOrganizationModel),
};

export const notificantValidation = {
  role: {},
  [Role.PERSON]: personValidation,
  [Role.ORGANIZATION]: organizationValidation,
  [Role.FOREIGN_ORGANIZATION]: foreignOrganizationValidation,
};

export default {
  name: 'Notificant',
  props: {
    v: {
      type: Object,
      required: true,
    },
    canDelete: {
      type: Boolean,
      required: true,
    },
  },
  components: { Person, Organization, ForeignOrganization },
  data: () => ({
    Role,
  }),
};
</script>

<style scoped></style>
